(function(){
  'use strict';

  function init(){
    var invite=document.getElementById('bu-invite');
    var launcher=document.getElementById('bu-launcher');
    var win=document.getElementById('bu-window');
    var inviteClose=document.getElementById('bu-invite-close');
    if(!invite||!launcher||!win)return;

    var dismissed=false;
    try{dismissed=sessionStorage.getItem('bettup_chat_invite_dismissed')==='1';}catch(error){}
    var elapsed=false;
    var engaged=window.scrollY>180;
    var snoozed=false;
    var syncing=false;

    Array.prototype.some.call(invite.childNodes,function(node){
      if(node.nodeType!==Node.TEXT_NODE)return false;
      node.nodeValue='Unsicher bei Kern oder Härtegrad?';
      return true;
    });

    function chatOpen(){
      return launcher.classList.contains('is-open')||win.classList.contains('visible');
    }

    function syncChatState(){
      document.body.classList.toggle('bettup-chat-open',chatOpen());
    }

    function syncInvite(){
      if(syncing)return;
      syncing=true;
      var shouldShow=!dismissed&&!snoozed&&elapsed&&engaged&&!chatOpen();
      invite.classList.toggle('bettup-invite-ready',shouldShow);
      invite.classList.toggle('visible',shouldShow);
      syncing=false;
    }

    function dismissInvite(permanent){
      snoozed=true;
      if(permanent){
        dismissed=true;
        try{sessionStorage.setItem('bettup_chat_invite_dismissed','1');}catch(error){}
      }
      syncInvite();
    }

    setTimeout(function(){
      elapsed=true;
      syncInvite();
    },22000);

    window.addEventListener('scroll',function(){
      if(!engaged&&window.scrollY>180)engaged=true;
      syncInvite();
    },{passive:true});

    if(inviteClose){
      inviteClose.addEventListener('click',function(){dismissInvite(true);},true);
    }

    launcher.addEventListener('click',function(){
      snoozed=true;
      setTimeout(function(){syncChatState();syncInvite();},0);
    },true);

    var close=document.getElementById('bu-close');
    if(close)close.addEventListener('click',function(){setTimeout(syncChatState,0);},true);

    document.addEventListener('focusin',function(event){
      if(event.target.closest('.variant-wrapper select,.variant-wrapper input,[data-bu-height-select],form[action*="/cart/add"] select'))dismissInvite(false);
    },true);

    document.addEventListener('change',function(event){
      if(event.target.matches('.variant-wrapper select,.variant-wrapper input,[data-bu-height-select],form[action*="/cart/add"] select'))dismissInvite(false);
    },true);

    new MutationObserver(function(){
      syncChatState();
      syncInvite();
    }).observe(launcher,{attributes:true,attributeFilter:['class']});

    new MutationObserver(function(){
      syncChatState();
      syncInvite();
    }).observe(win,{attributes:true,attributeFilter:['class']});

    new MutationObserver(function(){
      if(!syncing)syncInvite();
    }).observe(invite,{attributes:true,attributeFilter:['class']});

    syncChatState();
    syncInvite();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
